import versionsViewTemplate from "./VersionsViewTemplate";

var viewerStates = function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/versions");

    $stateProvider.state("versionsView", {
        url: "/versions",
        controller: "VersionsViewController",
        template: versionsViewTemplate,
        controllerAs: "versionsCtrl"
    });
};

viewerStates.$inject = ["$stateProvider", "$urlRouterProvider"];
export default viewerStates;
